<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row no-gutters">
        <div class="col-xl-9">
          <div class="auth-full-bg pt-lg-5 p-4">
            <div class="w-100">
              <div class="bg-overlay"></div>
              <div class="d-flex h-100 flex-column">
                <div class="p-4 mt-auto">
                  <div class="row justify-content-center">
                    <div class="col-lg-7">
                      <div class="text-center">
                        <h4 class="mb-3">Divnotex</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->

        <div class="col-xl-3">
          <div class="p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="my-auto" style="padding-top: 100px">
                  <div>
                    <h3 class="text-primary">Смена пароля</h3>
                    <p>Для продолжения работы с системой необходимо сменить пароль</p>
                  </div>

                  <div class="mt-4">
                    <form @submit.prevent="changePassword">
                      <b-form-group label="Новый пароль" class="password">
                        <b-form-input v-model="passNew1" :type="passwords.show.new1 ? 'text' : 'password'" />
                        <div class="password__button" @click="passwords.show.new1 = !passwords.show.new1">
                          <i v-if="!passwords.show.new1" class="bx bx-hide password__icon"></i>
                          <i v-if="passwords.show.new1" class="bx bx-show password__icon"></i>
                        </div>
                      </b-form-group>
                      <password-requirements
                        v-show="passNew1"
                        :password="passNew1"
                        @is-valid="isPasswordValid = $event"
                      />
                      <b-form-group label="Повторите пароль" class="password">
                        <b-form-input v-model="passNew2" :type="passwords.show.new2 ? 'text' : 'password'" />
                        <div class="password__button" @click="passwords.show.new2 = !passwords.show.new2">
                          <i v-if="!passwords.show.new2" class="bx bx-hide password__icon"></i>
                          <i v-if="passwords.show.new2" class="bx bx-show password__icon"></i>
                        </div>
                      </b-form-group>
                      <app-inline-alert variant="danger" v-show="passNew2 && passNew1 !== passNew2" permanent>
                        Пароли не совпадают!
                      </app-inline-alert>

                      <b-button
                        block
                        type="submit"
                        variant="primary"
                        class="mt-5 mb-5"
                        :disabled="!(passNew1 === passNew2 && isPasswordValid)"
                      >
                        Сменить пароль
                      </b-button>

                      <div style="display: flex; justify-content: center">
                        <b-spinner v-if="isFetching" variant="primary" />
                      </div>

                      <app-inline-alert v-model="passwordError" variant="danger">{{
                        passwordErrorMessage
                      }}</app-inline-alert>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { instanceLogin } from '@/api/instance';
import PasswordRequirements from '@/components/myComponents/PasswordRequirements';
import AppInlineAlert from '@/components/notifications/AppInlineAlert';

export default {
  name: 'ForceChangePassword',
  components: {
    PasswordRequirements,
    AppInlineAlert
  },
  data() {
    return {
      passNew1: '',
      passNew2: '',
      passwordError: false,
      passwordErrorMessage: '',
      isFetching: false,
      isPasswordValid: false,
      passwords: {
        show: {
          new1: false,
          new2: false
        }
      }
    };
  },
  methods: {
    async changePassword() {
      try {
        this.passwordError = false;
        this.isFetching = true;
        const response = await instanceLogin.post(
          '/v1/force_change_password',
          {
            new_password: this.passNew1,
            new_password_confirm: this.passNew2
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('tempToken')}`
            }
          }
        );

        if (response.data.errors.length === 0) {
          localStorage.removeItem('tempToken');
          await this.$store.dispatch('auth/loginUser', response.data.message.token);
        } else {
          this.passwordError = true;
          this.passwordErrorMessage = 'Произошла неизвестная ошибка';
        }
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        this.passwordError = true;
        if (e.response) {
          const error = e.response.data.errors.password[0];
          if (error === 'passwords not match') {
            this.passwordErrorMessage = 'Пароли не совпадают';
          } else if (error === 'complexity requirements not met') {
            this.passwordErrorMessage = 'Пароль не соответствует требованиям сложности';
          } else {
            this.passwordErrorMessage = 'Произошла неизвестная ошибка';
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.password {
  position: relative;
  &__button {
    position: absolute;
    top: 0;
    right: 0;
  }
  &__icon {
    margin-top: 4px;
    margin-right: 5px;
    font-size: 30px;
  }
}
</style>
